import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import 'react-big-calendar/lib/less/styles.less';
import 'react-toggle-switch/dist/css/switch.min.css';
import 'rc-drawer/assets/index.css';
import 'styles/bootstrap.scss';
import 'styles/app.scss';
import 'styles/app-rtl.scss';
import AppLocale from '../lngProvider';

import MainApp from 'app/index';
import SignIn from './SignIn';
import SignUp from './SignUp';
import { setInitUrl } from '../actions/Auth';
import { setThemeColor } from '../actions/Setting';
import asyncComponent from 'util/asyncComponent';
import { isAuthenticated, isAdmin, isSuperUser } from 'services/Authentication';
import { userSignOut } from 'actions/Auth';

import {
    DARK_CYAN,
} from 'constants/ThemeColors';

const RestrictedRoute = ({ component: Component, ...rest }) => {
    const authenticated = isAuthenticated();
    console.log('Restricted Route isAuthenticated = '.concat(authenticated));
    return (
        <Route
            {...rest}
            render={props =>
                authenticated
                    ? <Component {...props} />
                    : <Redirect
                        to={{
                            pathname: '/signin',
                            state: { from: props.location }
                        }}
                    />}
        />
    );
};

class App extends Component {
    componentDidMount() {
        if (this.props.initURL === '') {
            this.props.setInitUrl(this.props.history.location.pathname);
        }
        this.props.setThemeColor(DARK_CYAN);
        const body = document.body.classList;
        body.remove(this.props.themeColor);
        body.remove('dark-theme');
        body.add(DARK_CYAN);
        document.body.classList.add(this.props.themeColor);
    }


    render() {
        const { match, location, locale, initURL, isDirectionRTL, userSignOut } = this.props;
        if (location.pathname === '/web-view') {
            console.log(location ?.search);
        }
        if (location.pathname === '/session/clear') {
            userSignOut(); // clear auth variables as they have become stale
            return (<Redirect to={'/signin'} />);
        }
        if (location.pathname === '/') {
            if (!isAuthenticated()) {
                userSignOut(); // clear auth variables as they have become stale
                return (<Redirect to={'/signin'} />);
            } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
                // determine which dashboard to go to
                // if SUPER_USER then head to the admin dashboard
                // if an administrator (user with role = gold) head to the organisation dashboard
                // if an employee then head to the employee dashboard
                if (isSuperUser()) {
                    return (<Redirect to={'/app/agile-dashboard/default'} />);
                } else if (isAdmin()) {
                    return (<Redirect to={'/app/org-dashboard/default'} />);
                }
                return (<Redirect to={'/app/emp-dashboard/default'} />);
            } else {
                return (<Redirect to={initURL} />);
            }
        }

        // for RTL Support
        if (isDirectionRTL) {
            document.body.classList.add('rtl');
        } else {
            document.body.classList.remove('rtl');
        }

        const currentAppLocale = AppLocale[locale.locale];
        return (
            <IntlProvider
                locale={currentAppLocale.locale}
                messages={currentAppLocale.messages}
            >
                <div className="app-main">
                    <Switch>
                        <RestrictedRoute path={`${match.url}app`}
                            component={MainApp} />
                        <Route path='/signin' component={SignIn} />
                        <Route path='/signup' component={SignUp} />
                        <Route path='/web-view' component={SignIn} />
                        <Route
                            component={asyncComponent(() => import('app/routes/extraPages/routes/404'))} />
                    </Switch>
                </div>
            </IntlProvider>
        );
    }
}

const mapStateToProps = ({ settings, auth }) => {
    const { locale, isDirectionRTL } = settings;
    const { authUser, initURL, identity } = auth;
    return { locale, isDirectionRTL, authUser, initURL, identity };
};

export default connect(mapStateToProps, { setInitUrl, setThemeColor, userSignOut })(App);



// WEBPACK FOOTER //
// ./containers/App.js